import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-settings',
  templateUrl: './users-settings.component.html',
  styleUrls: ['./users-settings.component.scss']
})
export class UsersSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
